/** Grudge Match Party wordmark: stacked display type with a tilted PARTY ticket. */
export function Logo({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const scale = size === 'lg' ? 'text-[clamp(2.4rem,11vw,4.5rem)]' : size === 'md' ? 'text-[clamp(1.8rem,8vw,2.25rem)]' : 'text-2xl';
  return (
    <div className="inline-flex flex-col items-center leading-none select-none" aria-label="Grudge Match Party">
      <span className={`font-display font-black tracking-tight ${scale}`} style={{ textShadow: '0 4px 0 #ff3d7f, 0 8px 0 #2a1450' }}>
        GRUDGE<span className="text-brand-2">·</span>MATCH
      </span>
      <span
        className={`font-display font-black -rotate-3 mt-2 px-4 py-1 rounded-xl bg-brand-2 text-ink ${size === 'lg' ? 'text-3xl' : size === 'md' ? 'text-xl' : 'text-sm'}`}
        style={{ boxShadow: '0 4px 0 #b88a00' }}
      >
        PARTY
      </span>
    </div>
  );
}
